import { render, staticRenderFns } from "./ConfirmationDemo.vue?vue&type=template&id=c9bee81a&"
import script from "./ConfirmationDemo.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports